// cat > /home/claude/redesign/src/App.js << 'JSEOF'
import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import HomePage from "./components/HomePage";
import Login from "./components/Login";
import AdminDashboard from "./components/AdminDashboard";
import axios from "axios";
import ProtectedRoute from "./components/ProtectedRoute";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:10000";
const API = `${BACKEND_URL}/api`;
function App() {

  useEffect(() => {
    const ping = () => axios.get(`${API}/`).catch(() => {});
    ping();

    const t = setInterval(ping, 10 * 60 * 1000);

    return () => clearInterval(t);

  }, []);

  return (

    <BrowserRouter>

      <Routes>

        <Route
          path="/"
          element={<HomePage />}
        />

        <Route
          path="/login"
          element={<Login />}
        />

        <Route
          path="/admin"
          element={
            <ProtectedRoute>
                <AdminDashboard />
            </ProtectedRoute>
        }
        />

      </Routes>

    </BrowserRouter>

  );
}

export default App;